import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

import { OwnerService } from '../../../service/owner/owner.service';
import { DeliAreaService } from '../../../service/deli-area/deli-area.service';
import { DeliRouteService } from '../../../service/deli-route/deli-route.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9174.component.html',
  styleUrls: ['wa9174.component.css']
})
export class Wa9174Component implements AfterViewInit {
  public componentTitle = 'WA9174:配送ルートマスタ登録';

  // drop down list
  public owners: any;
  public deliareas: any;
  public alldeliareas: any;

  public ownerId: number;
  public ownerdisplayTx: FormControl;
  public deliareadisplayTx: FormControl;
  public delirouteCd: FormControl;
  public delirouteTx: FormControl;
  public deliareaId: number;

  public filteredOwnerOptions: Observable<string[]>;
  public filteredDeliareaOptions: Observable<string[]>;

  public validation = validation;

  public working = false;
  private errorInfo = '';

  constructor(
    private router: Router,
    private ownerService: OwnerService,
    private deliAreaService: DeliAreaService,
    private deliRouteService: DeliRouteService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.ownerdisplayTx = new FormControl('', Validators.required);
    this.deliareadisplayTx = new FormControl('', Validators.required);
    this.delirouteCd = new FormControl('', [
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.delirouteCd.maxLength)
    ]);

    this.delirouteTx = new FormControl('', [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.delirouteTx.maxLength)
    ]);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;
    this.ownerService.get().then(outputJson => {
      console.log('ownerService.outputJson:', JSON.stringify(outputJson));
      this.owners = outputJson.owners;
    });
    this.deliAreaService
      .get(1)
      .then(outputJson => {
        this.working = false;
        console.log(JSON.stringify(outputJson));
        this.alldeliareas = outputJson.deliareas;
        this.deliareas = this.getDeliareaOwners();
        this.filteredOwnerOptions = this.ownerdisplayTx.valueChanges.startWith(null).map(val => (val ? this.ownerFilter(val) : this.owners));
        this.filteredDeliareaOptions = this.deliareadisplayTx.valueChanges.startWith(null).map(val => (val ? this.deliareaFilter(val) : this.deliareas));
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    console.log('ownerdisplayTx:', this.ownerdisplayTx);
  }

  onSubmit() {
    var delirouteCd = this.delirouteCd.value.trim();
    var delirouteTx = this.delirouteTx.value.trim();
    let errors = false;
    if (this.ownerdisplayTx.errors !== null) {
      this.ownerdisplayTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.deliareadisplayTx.errors !== null) {
      this.deliareadisplayTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.delirouteCd.errors !== null) {
      this.delirouteCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.delirouteTx.errors !== null) {
      this.delirouteTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    this.working = true;
    this.deliRouteService
      .post(this.ownerId, delirouteCd, delirouteTx, this.deliareaId, 'wa9174')
      .then(outputJson => {
        this.working = false;
        this.router.navigate(['wa9173']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ownerFilter(val: string): string[] {
    return this.owners.filter(owner => owner.ownerdisplayTx.indexOf(val) !== -1);
  }

  deliareaFilter(val: string): string[] {
    this.ownerId = this.getOwnerId();
    this.deliareas = this.getDeliareaOwners();
    if (this.deliareas !== undefined) {
      return this.deliareas.filter(deliarea => deliarea.deliareadisplayTx.indexOf(val) !== -1);
    }
  }

  changeOwner(event: string) {
    this.ownerId = this.getOwnerId();
    this.deliareas = this.getDeliareaOwners();
    this.deliareaId = undefined;
    this.deliareadisplayTx.setValue('');
  }

  changeDeliarea(event: number) {
    this.deliareaId = this.getDeliareaId();
  }

  getOwnerId(): number {
    if (this.owners !== undefined && this.ownerdisplayTx.value.trim() !== '') {
      var selectedOwners = this.owners.filter((item, index) => {
        if (item.ownerdisplayTx === this.ownerdisplayTx.value.trim()) return true;
      });
      if (selectedOwners.length > 0) {
        return selectedOwners[0]['ownerId'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  getDeliareaOwners(): any[] {
    if (this.ownerId !== undefined && this.alldeliareas !== undefined) {
      var deliareaOwners = this.alldeliareas.filter((item, index) => {
        if (item.ownerId === this.ownerId) return true;
      });
    }
    return deliareaOwners;
  }

  getDeliareaId(): number {
    this.deliareas = this.getDeliareaOwners();
    if (this.deliareas !== undefined && this.deliareadisplayTx.value.trim() !== '') {
      var selectedDeliareas = this.deliareas.filter((item, index) => {
        if (item.deliareadisplayTx === this.deliareadisplayTx.value.trim()) return true;
      });
      if (selectedDeliareas.length > 0) {
        return selectedDeliareas[0]['deliareaId'];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9174/wa9174.component.ts